import { combineReducers } from "redux";

import template from "redux/slices/template";
import authToken from "redux/slices/auth";

import vw_zilla from "redux/slices/vw_zilla";
import vw_nagar_khanda from "redux/slices/vw_nagar_khanda";
import vw_members from "redux/slices/vw_members";
import zilla from "redux/slices/zilla";
import vibhag from "redux/slices/vibhag";
import nagar_khanda from "redux/slices/nagar_khanda";
import members from "redux/slices/members";
import desig_level from "redux/slices/desig_level";
import designation from "redux/slices/designation";
import blood_grp from "redux/slices/blood_grp";
import nagar_type from "redux/slices/Dashboard"
import vw_samithi_members from "redux/slices/vw_samithi_members";
import samithi_members from "redux/slices/samithi_members";
import gramam from "redux/slices/gramam";


const rootReducer = combineReducers({ template,authToken,vw_zilla,vw_samithi_members,vw_nagar_khanda,vw_members,zilla,vibhag,samithi_members,nagar_khanda,nagar_type,members,gramam,designation,desig_level,blood_grp });
export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;

